import React from 'react';

const AuthBackground: React.FC = () => {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="auth-glow-surface absolute inset-0"></div>
      <div className="auth-rhombus-grid absolute inset-0"></div>
      <div className="auth-rhombus-grid auth-rhombus-grid-accent absolute inset-0"></div>
      <div className="auth-glow-orb auth-glow-orb-primary"></div>
      <div className="auth-glow-orb auth-glow-orb-secondary"></div>
      <div className="auth-glow-orb auth-glow-orb-accent"></div>
      <div className="auth-glow-core absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full"></div>
      <div className="auth-glow-vignette absolute inset-0"></div>
    </div>
  );
};

export default AuthBackground;
